<template>
	<lineChart
		:chart-data="chartData"
		:chart-options="mergedOptions"
		:width="width"
		:height="height"></lineChart>
</template>
<script>
	import { computed, ref } from "vue";
	import { Line } from "vue-chartjs";
	import {
		Chart as ChartJS,
		Title,
		Tooltip,
		Legend,
		CategoryScale,
		LinearScale,
		LineElement,
		PointElement
	} from "chart.js";

	ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement);

	export default {
		components: {
			lineChart: Line
		},
		props: {
			labels: {
				type: Array,
				default: () => {
					return [];
					//labels are expected in the following format:
					//["January", "February", "March"]
				}
			},
			datasets: {
				type: Array,
				default: () => {
					return [];
					//datasets are expected in the following format:
					//[ { label: 'legendLabel', tension: 0.1, fill: false, data: [1, 2, 3] } ]
					//The number of data indices should match the length of label's.
				}
			},
			options: {
				type: Object,
				default: () => {
					return { responsive: true };
				}
			},
			width: {
				type: Number,
				default: 400
			},
			height: {
				type: Number,
				default: 200
			}
		},
		setup(props, context) {
			const chartData = computed(() => {
				return {
					labels: props.labels,
					datasets: props.datasets
				};
			});

			//Inherited properties go here. Can be overwritten.
			const mergedOptions = ref({ ...{}, ...props.options });

			return {
				mergedOptions,
				chartData
			};
		}
	};
</script>
